'use strict';

/**
 * canManageMagicLink(currentUser, currentAccount) — pure gate for the
 * "Magic link" feature on the app instance edit screen (epic #684).
 *
 * Magic-link management is an ALPHA feature. Access is granted by EITHER of
 * two independent paths:
 *
 *   1. the account is on the alpha programme (`account.alpha === true`), which
 *      grants every user on that account; or
 *   2. the user's email is on the internal allow-list below.
 *
 * The allow-list is deliberately RETAINED alongside alpha rather than replaced
 * by it, so internal access never depends on a database flag being set
 * correctly. Account-admin status still grants nothing on its own.
 *
 * Returns a strict boolean so it drives an ng-if cleanly. The email match is
 * exact (not substring) so lookalikes such as
 * `piotr.seefeld@gmail.com.evil.com` never pass, and `alpha` must be a real
 * boolean true so a stray truthy string cannot open the gate. This mirrors the
 * "absent input → inert result" idiom of build-magic-link-url.js (#827).
 *
 * NOTE: this is the CLIENT-side gate — it hides the button. The authoritative
 * check lives in rocket-api server/models/magic-link.js, which rejects
 * forApp/regenerate for non-alpha accounts with a 403.
 *
 * @param {{email?: string}|null|undefined} currentUser
 * @param {{alpha?: boolean}|null|undefined} currentAccount
 * @returns {boolean}
 */
var MAGIC_LINK_EMAIL_ALLOW_LIST = ['gosia.seefeld@gmail.com', 'piotr.seefeld@gmail.com'];

function canManageMagicLink(currentUser, currentAccount) {
    if (!currentUser) return false;

    // Path 1: the account is on the alpha programme.
    if (currentAccount && currentAccount.alpha === true) return true;

    // Path 2: the internal email allow-list escape hatch.
    if (typeof currentUser.email !== 'string') return false;
    var email = currentUser.email.trim().toLowerCase();

    return MAGIC_LINK_EMAIL_ALLOW_LIST.indexOf(email) !== -1;
}

// CommonJS export for Mocha unit tests (guarded so it is a no-op inside the
// concatenated Angular bundle, where `canManageMagicLink` is a plain global —
// mirrors the build-magic-link-url.js pattern from #827).
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = { canManageMagicLink, MAGIC_LINK_EMAIL_ALLOW_LIST };
}
